<template>
  <div class="table">
    <div class="col head check"></div>
    <div class="col head name">
      <span>Товары <template v-if="not_available">не</template> в наличии</span>
    </div>
    <div class="col head"><span>Кол-во</span></div>
    <div class="col head"><span>Розничная цена</span></div>
    <div class="col head"><span>Ваша цена</span></div>
    <div class="col head"><span>Итого розница</span></div>
    <div class="col head"><span>Ваши бонусы</span></div>
    <div class="col head last"><span>Итого</span></div>

    <template v-for="item in basketData" :key="item">

      <template v-if="!item.deleted">
        <div class="col val check">
          <div class="red" :class="[{active: not_available}]"></div>
          <div class="check_del">
            <standart-checkbox :checked="item.checked" @change="item.checked = $event"></standart-checkbox>
            <basket-button @click="deleteProduct(item)"></basket-button>
          </div>
        </div>
        <div
            class="col val title name"
            @click="navigate(item)"
        >
          <template v-if="item.image != null">
            <img @error="error_load_img(item)" :src="item.image">
          </template>
          <template v-if="item.image == null">
            <img :src="empty_image">
          </template>
          <div class="main">
            <span class="title" v-html="item.name"></span>
            <span class="article">{{item.article}}</span>
          </div>
        </div>
        <div class="col val quantity">
          <div class="quantity-controller">
            <svg @click="minusBasket(item)" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M4.5 9H13.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <input class="quantity_value" type="number" @input="setBasket($event.target.value, item)" :value="item.quantity">
            <svg @click="plusBasket(item)" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M4.5 9H13.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 13.5V4.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="col val"><span class="m_desc">Розничная цена</span><span>{{item.price}}</span></div>
        <div class="col val"><span class="m_desc">Итого розница</span><span>{{item.custom_price}}</span></div>
        <div class="col val"><span class="m_desc">Ваша цена</span><span>{{item.total_price}}</span></div>
        <div class="col val b"><span class="m_desc">Ваша цена</span><span>{{item.bonuses}}</span></div>
        <div class="col val total">
          <div class="m_quantity">
            <div class="quantity-controller">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M4.5 9H13.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="quantity_value">{{item.quantity}}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M4.5 9H13.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 13.5V4.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="ttl"><span class="m_desc">Итого</span><span>{{item.total_custom_price}}</span></div>
        </div>
      </template>

      <template v-if="item.deleted">
        <div class="col val deleted name">{{item.name}}</div>
        <div class="col val deleted article">{{item.article}}</div>
        <div class="col val deleted price">
          <span>{{item.price}}</span>
          <span class="m_deleted_article">{{item.article}}</span>
        </div>
        <div class="col val deleted return">
          <standart-button @click="returnProduct(item)" text="Вернуть товар"></standart-button>
        </div>
      </template>

      <div class="col sep"></div>
    </template>

  </div>
</template>

<script>
import BasketButton from "@/components/share/BasketButton";
import StandartCheckbox from "@/components/share/StandartCheckbox";
import StandartButton from "@/components/share/StandartButton";
import axios from "axios";

export default {
  name : "BasketProducts",
  props : {
    not_available : Boolean
  },
  components: {
    BasketButton,
    StandartCheckbox,
    StandartButton
  },
  data() {
    return{
      empty_image : require('@/assets/catalog/product/empty.svg'),

      basketData: [],
    }
  },
  methods : {
    error_load_img: async function(product) {
      product.image = this.empty_image;
    },
    navigate : function(product) {
      this.$router.push(
          {
            name:'catalog_product',
            params: {
              product: product.product_id,
              section: product.section_code
            }
          }
      )
    },
    setBasket: async function(qnt, product) {
      if(!(parseInt(qnt) >= 1)) {return;}

      let res = await axios.get(window.api_url + "basket/set?id="+product.product_id+"&quantity="+qnt+"&api=y");
      console.log(res);
      this.$emit("basket_changed");
    },
    plusBasket : async function(product) {
      let qnt = product.quantity + 1;

      let res = await axios.get(window.api_url + "basket/set?id="+product.product_id+"&quantity="+qnt+"&basket_action=plus_step&api=y");
      //product.quantity = res.data.data;
      console.log(res);

      this.$emit("basket_changed");
    },
    minusBasket : async function(product) {
      if(product.quantity <= 1) {return;}
      let qnt = product.quantity - 1;

      let res = await axios.get(window.api_url + "basket/set?id="+product.product_id+"&quantity="+qnt+"&basket_action=minus_step&api=y");
      //product.quantity = res.data.data;
      console.log(res);

      this.$emit("basket_changed");
    },
    deleteProduct : async function(product) {
      let qnt = product.quantity;
      await axios.get(window.api_url + "basket/set?id="+product.product_id+"&quantity="+qnt+"&basket_action=minus&api=y");
      product.deleted = true;

      this.$emit("basket_changed");
    },
    returnProduct : async function(product) {
      let qnt = product.quantity;
      await axios.get(window.api_url + "basket/set?id="+product.product_id+"&quantity="+qnt+"&basket_action=plus&api=y");
      product.deleted = false;

      this.$emit("basket_changed");
    }
  }
}
</script>

<style scoped>
.table {
  border: 1px solid var(--Border, #EDEDED);
  display: grid;
  grid-template-columns: auto 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  border-radius: 8px;
  background: var(--White);
  margin-bottom: 20px;
}

.col {
  padding: 14px 20px;
  justify-content: center;
  display: flex;
  align-items: center;
}

.col.head.check {
  border-right: unset;
  padding-right: 10px;
}

.col.head.last {
  border-right: unset;
}

.col.head.name {
  justify-content: center;
  display: flex;
  padding-left: 0px;
}

.col.head {
  border-right: 1px solid var(--Border, #EDEDED);
  border-bottom: 1px solid var(--Border, #EDEDED);
}

.col.head span {
  color: var(--Gray, #656565);
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.col.val.check {
  padding-right: 8px;
}

.col.val.check .red{
  margin-right: 20px;
  height: 100%;
  width: 2px;
  background: transparent;
  margin-left: -20px;
}

.col.val.check .red.active{
  background: #FA4B61;
}

.check_del {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.col.val span {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.col.val.b span {
  color: var(--Blue, #1B78BC);
}

.col.sep {
  grid-column: 1/9;
  border-bottom: 1px solid var(--Border, #EDEDED);
  padding: 0px;
}

.col.sep:last-child {
  border-bottom: unset;
  padding: 0px;
}

.table .val.title {
  font-weight: 500;
  cursor: pointer;
}

.table .val.title.name {
  justify-content: start;
  gap: 12px;
  width: 346px;
  padding-left: 0px;
}

.table .val.title.name img{
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  background: #fff;
}

.table .val.title.name .main{
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: start;
  align-items: start;
  text-align: left;
}

.table .val.title.name .main .title{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;

  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.table .val.title.name .main .article{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
}

.col.deleted {
  background: var(--BG, #F8F8F8);
}

.col.deleted.name {
  grid-column: 1 / 3;
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  justify-content: start;
}

.col.deleted.article {
  grid-column: 5 / 3;
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.col.deleted.price {
  grid-column: 5 / 7;
  color: var(--Black, #222);
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.col.deleted.return {
  grid-column: 7 / 9;
  justify-content: end;
}

.table .quantity-controller {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  height: 38px;
  width: 83px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.table .quantity-controller .quantity_value {
  width: 15px;
  border: none;
  outline: none;
  background: transparent;
  text-align: center;
}

.table .quantity-controller svg{
  cursor: pointer;
}

.m_desc {
  display: none;
}

.m_quantity {
  display: none;
}

.m_deleted_article {
  display: none;
}



/*MOBILE*/
@media (max-width: 1250px)
{
  .table {
    grid-template-columns: 1fr;
  }

  .table .col.head {
    display: none;
  }

  .table .col.val {
    grid-column: 1/8;
    justify-content: space-between;
    padding-top: 0px;
    padding-bottom: 10px;
  }

  .col.val.check {
    padding: 18px 18px 12px 18px;
    flex-direction: column;
  }

  .col.val.check .red {
    margin: 0px;
    width: 100%;
    height: 2px;
    margin-top: -18px;
    margin-bottom: 18px;
  }

  .check_del {
    width: 100%;
    flex-direction: row;
  }

  .table .val.title.name {
    width: auto;
    padding: 0px 18px 14px 18px;
  }

  .col.val.quantity {
    display: none;
  }

  .m_quantity {
    display: block;
  }

  .col.val span.m_desc {
    display: block;
    color: var(--Gray, #656565);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }

  .m_quantity .quantity-controller {
    width: 123px;
    gap: 20px;
  }

  .col.val.total {
    padding-top: 12px;
    padding-bottom: 18px;
  }

  .col.val.total .ttl{
    display: flex;
    align-items: end;
    flex-direction: column;
    gap: 4px;
  }

  .col.val.deleted.name {
    padding-top: 18px;
    padding-bottom: 8px;
  }

  .col.val.deleted.article {
    display: none;
  }

  .col.val span.m_deleted_article {
    display: block;
    color: var(--Gray, #656565);
  }

  .col.deleted.return {
    padding-bottom: 18px;
    padding-top: 10px;
  }

  .table .standart_button {
    width: 100%;
  }
}
</style>